import React, { lazy, Suspense } from 'react';
import PrivateRoute from '../../routes/PrivateRoute';
import PublicRoute from '../../routes/PublicRoute';
import { Spinner } from '../Common/Spinner';

const BlogListTable = lazy(() => import('./List/BlogListTable'));
const BlogForm = lazy(() => import('./BlogForm'));
const BlogList = lazy(() => import('./List/BlogList'));

const BlogRouter = (props) => (
    <Suspense fallback={<Spinner />}>
        <PrivateRoute path="/list/blogs" searchString={props.searchString} component={BlogListTable} exact />
        <PrivateRoute path="/blogs/:id?" component={BlogForm} exact />
        <PublicRoute path="/blogs/:organization_id" component={BlogList} exact />
    </Suspense>
);

export default BlogRouter;